import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isStoredAuthExpired, clearAuth } from "../utils/auth";

const AuthExpiryWatcher = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const expired = isStoredAuthExpired();

    if (expired && location.pathname.startsWith("/dashboard")) {
      clearAuth();
      navigate("/login?session=expired", {
        replace: true,
      });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default AuthExpiryWatcher;